import { useContext } from "react";
import { useNavigate } from "react-router-dom";
import {
  FiTool,
  FiGlobe,
  FiBookOpen,
  FiPackage,
  FiDollarSign,
  FiCreditCard,
} from "react-icons/fi";
import { AuthContext } from "../../../context/AuthContext";
import { isProjectManager } from "../../../utils/constants/accountType";

const valueOptions = [
  { name: "Services",        path: "/system-values/services",        icon: FiTool,       color: "bg-brand-50 text-brand-600",     border: "border-brand-100"   },
  { name: "Language Pairs",  path: "/system-values/language-pairs",  icon: FiGlobe,      color: "bg-teal-50 text-teal-600",     border: "border-teal-100"   },
  { name: "Specializations", path: "/system-values/specializations", icon: FiBookOpen,   color: "bg-purple-50 text-purple-600", border: "border-purple-100" },
  { name: "Units",           path: "/system-values/units",           icon: FiPackage,    color: "bg-amber-50 text-amber-600",   border: "border-amber-100"  },
  { name: "Currencies",      path: "/system-values/currencies",      icon: FiDollarSign, color: "bg-green-50 text-green-600",   border: "border-green-100"  },
  { name: "Payment Methods", path: "/system-values/payment-methods", icon: FiCreditCard, color: "bg-rose-50 text-rose-600",     border: "border-rose-100"   },
];

const OptionCard = ({ opt, navigate }) => {
  const Icon = opt.icon;
  return (
    <button
      onClick={() => navigate(opt.path)}
      className={`group flex items-center gap-3 bg-white border ${opt.border} rounded-lg px-4 py-3 shadow-sm hover:shadow-md transition-all duration-200 hover:-translate-y-0.5 focus:outline-none focus:ring-2 focus:ring-brand-500`}
    >
      <div className={`inline-flex items-center justify-center w-8 h-8 rounded-md shrink-0 ${opt.color}`}>
        <Icon size={16} />
      </div>
      <span className="text-sm font-semibold text-gray-800 group-hover:text-brand-600 transition-colors">
        {opt.name}
      </span>
    </button>
  );
};

const SystemValuesPage = () => {
  const navigate = useNavigate();
  const { user } = useContext(AuthContext);
  const projectManager = isProjectManager(user);
  const values = projectManager
    ? valueOptions.filter((opt) => opt.path !== "/system-values/payment-methods")
    : valueOptions;

  return (
    <div className="space-y-8">
      {/* Header */}
      <div>
        <h1 className="text-[22px] font-semibold tracking-tight text-gray-900">System Values</h1>
        <p className="mt-1 text-sm text-gray-500">
          Configure the core settings that power your projects, invoices, and payments.
        </p>
      </div>

      <div className="space-y-3">
        <div className="flex items-center gap-2">
          <h2 className="text-sm font-semibold text-gray-500 uppercase tracking-widest">
            Values
          </h2>
          <div className="flex-1 h-px bg-gray-200" />
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3">
          {values.map((opt) => (
            <OptionCard key={opt.name} opt={opt} navigate={navigate} />
          ))}
        </div>
      </div>
    </div>
  );
};

export default SystemValuesPage;